/// EditorPanel: Wraps EditorCanvas with tab-specific state.
///
/// NOTE: This component stays mounted for ALL open tabs (not just the
/// active one). The parent Workspace hides inactive panels with
/// display:none to preserve WASM worker state across tab switches.
/// Active-tab management is handled by Workspace/TabBar, not here.
/// Edit and zoom commands from the toolbar are handled by EditorCanvas
/// via custom event listeners (flowy:editCommand, flowy:zoomCommand).

import { EditorCanvas } from "./EditorCanvas";
import type { EditorTab } from "@/types/editor";
import type { PanelId } from "@/stores/editorStore";

// ---------------------------------------------------------------------------
// Props
// ---------------------------------------------------------------------------

interface EditorPanelProps {
  /** The tab this panel is rendering. */
  tab: EditorTab;
  /** Panel identity for per-panel event isolation. */
  panelId: PanelId;
}

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export function EditorPanel({ tab, panelId }: EditorPanelProps) {
  return (
    <div className="flex flex-1 flex-col min-h-0 overflow-hidden">
      <EditorCanvas tabId={tab.id} editorType={tab.editorType} panelId={panelId} />
    </div>
  );
}
